export const checkpointsFr = {
    actions: {
        eraseDetections:
            'Réinitialiser les détections supprimera toutes les détections actuellement enregistrées. Êtes-vous sûr(e) ?',
        eraseDetectionsTitle: 'Réinitialiser les détections',

        reassignDevice: "Souhaitez-vous réassigner l'appareil {device} au POI {checkpoint} ?",
        reassignDeviceTitle: 'Réassigner un appareil'
    },
    api: {
        error: {
            createCheckpoint: 'Erreur lors de la création du POI {name}',
            deleteCheckpoint: 'Erreur lors de la suppression du POI {name}',
            fetchCheckpoint: 'Erreur lors de la récupération du POI',
            fetchCheckpoints: 'Erreur lors de la récupération des POIs',
            updateCheckpoint: 'Erreur lors de la modification du POI {name}'
        },
        success: {
            createCheckpoint: 'Création du POI {name} effectuée avec succès !',
            deleteCheckpoint: 'Suppression du POI {name} effectuée avec succès !',
            fetchCheckpoint: 'Récupération du POI effectuée avec succès !',
            fetchCheckpoints: 'Récupération des pois effectuée avec succès !',
            updateCheckpoint: 'Modification(s) du POI {name} effectuée(s) avec succès !'
        }
    },
    buttons: {
        showAll: 'Montrer tous les POIs',
        hideAll: 'Cacher les POIs supplémentaires'
    },

    model: {
        associates: 'Appareils associés',
        comments: 'Commentaire',
        name: 'Nom du POI'
    },
    detail: {
        associates: 'Associer un appareil',
        associateDevice: "Associer l'appareil",
        noDeviceAssociated: 'Aucun appareil associé',
        dissociateDevice: "Dissocier l'appareil"
    },
    title: {
        associateDeviceTitle: 'Associer des appareils',
        informationsTitle: 'Informations',
        partnerTitle: 'Informations du partenaire',
        actionsTitle: 'Actions'
    }
}
